import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { ChipsItem, ChipsSize } from '@/components/chips/chips.types.ts';
import { SegmentedChips } from '@/components/chips/SegmentedChips.tsx';
import { useUserSettings } from '@/hooks';
import { Languages } from '@/localization';

type LanguageSelectorProps = {
  /** Rendered above the chips; omit where space is tight, e.g. the shortcuts dialog footer. */
  label?: string;
  size?: ChipsSize;
};

export const LanguageSelector = ({ label, size = 'small' }: LanguageSelectorProps) => {
  const { t } = useTranslation();
  const { language, setLanguage } = useUserSettings();

  const languageItems = useMemo<ChipsItem<Languages>[]>(
    () => [
      { id: Languages.English, label: t('en'), value: Languages.English },
      { id: Languages.Norwegian, label: t('nb'), value: Languages.Norwegian },
    ],
    [t]
  );
  const selectedLanguage = languageItems.find(item => item.value === language) ?? languageItems[0];

  return (
    <SegmentedChips
      label={label}
      size={size}
      items={languageItems}
      value={selectedLanguage}
      onChange={item => item.value && setLanguage(item.value)}
    />
  );
};
